/**
 * A ticket's admission code as a QR, generated entirely in the bundle (qrcode-generator, zero
 * dependencies) — the code is the credential, so it never travels to a chart service.
 */
import qrcode from "qrcode-generator";
import { useMemo } from "react";

export function TicketQr({ code }: { code: string }) {
  const { path, modules } = useMemo(() => {
    // Type 0 picks the smallest version that fits; M-level correction survives a cracked
    // screen or a phone at an angle at the door.
    const qr = qrcode(0, "M");
    qr.addData(code);
    qr.make();
    const count = qr.getModuleCount();
    let d = "";
    for (let row = 0; row < count; row += 1) {
      for (let col = 0; col < count; col += 1) {
        if (qr.isDark(row, col)) d += `M${col} ${row}h1v1h-1z`;
      }
    }
    return { path: d, modules: count };
  }, [code]);

  return (
    <svg
      className="ticket-qr"
      viewBox={`0 0 ${modules} ${modules}`}
      role="img"
      aria-label="Ticket code — show at the door"
      shapeRendering="crispEdges"
    >
      <rect width={modules} height={modules} fill="#fff" />
      <path d={path} fill="#000" />
    </svg>
  );
}
